import { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { toast } from 'react-toastify'; // Add this for toast notifications
import useFetch from '../hooks/useFetch'; // Update the import path for your useFetch hook
import { RemoveCircleOutlineTwoTone, EditNote } from '@mui/icons-material';
import { useLocation } from "react-router-dom";
import MuxActions from "../components/Talktape/MuxActions"
import Tooltip from "@mui/material/Tooltip";

interface PerformanceCardProps {
  id: number;
  type: "judge" | "admin";
  performanceColor: string;
  entry_number: string;
  performance_type: string;
  division: string;
  performers: JSON;
  program: string;
  routine: string;
  secondLastColumn?: number;
  lastColumn?: string;
  is_editing_allowed: boolean;
  ranking_final_score:number;
  fetchData: () => void;
  showEditPerformanceForm?: (pid:number, entryid:string, pdivision:number, routine:string, user_programdirector_id:number, ptime: string, performers: string, playlist_number: string, style: string, pclass: string, grade: string, level: string, performer_count: string, description: string, performance_type: string, song_id: number, event_id: number) => void;
  division_id?: number;
  routine_id?: number;
  user_programdirector_id?: number;
  performance_time?: string;
  playlist_number?: string;
  song_id?: number;
  style?: string;
  pclass?: string;
  grade?: string;
  level?: string;
  performer_count?: string;
  description?: string;
  event_id?: number;
  pdivisionStatus?: string;
  edit_delete_allowed?: boolean;
   talktape?: {
    id: number;
    entry_number: number;
    performance_id: number;
    talktape_video_title: string;
    mux_asset_id: string | null;
    mux_playback_id: string | null;
    mux_playback_url: string | null;
    status: "pending" | "waiting" | "ready";
    error_message: string | null;
  };
  onTalktapeUpdate?: (updatedTalktape: any) => void;
}

const PerformanceCard: React.FC<PerformanceCardProps> = ({
  id,
  type,
  performanceColor,
  entry_number,
  performance_type,
  division,
  performers,
  program,
  routine,
  secondLastColumn,
  lastColumn,
  is_editing_allowed,
  ranking_final_score,
  fetchData,
  showEditPerformanceForm,
  division_id,
  //routine_id,
  user_programdirector_id,
  performance_time,
  playlist_number,
  song_id,
  style,
  pclass,
  grade,
  level,
  performer_count,
  description,
  event_id,
  pdivisionStatus,
  edit_delete_allowed,
  talktape,
  onTalktapeUpdate,
}) => {
  const [hasCalledRemovePerforamnce, setHasCalledRemovePerforamnce] = useState(false);
  
  const navigate = useNavigate();
  const currentRole = JSON.parse(localStorage.getItem("user") || '{}').current_role;
  
  const { data: removedPerformanceData, isLoading: isRemovePerformanceLoading, error: errorData, fetchData: fetchRemovePerformance, hasFetched: removePerformanceFetched } = useFetch({
    url: `${import.meta.env.VITE_API_URL}/admin/remove_performance`,
    method: "POST",
  });

  // Function to handle delete action
  const handleDelete = async () => {
    try {
      const removePerformance = window.confirm(
        "Are you sure you want to remove Entry "+entry_number+"?"
      );
      if ( !removePerformance) {
        return;
      }
      setHasCalledRemovePerforamnce(false);
      fetchRemovePerformance({performance_id:id, entry_number});
    } catch (err) {
      console.warn(err);
      toast.warn('Error deleting performance'); // Handle any other errors and show warning
    }
  };
const handleTalktapeUpdate = (updatedTalktape: any) => {
  if (onTalktapeUpdate) {
    onTalktapeUpdate(updatedTalktape);
  }
};

  useEffect(() => {
    //if (!errorContentData?.success) {
    //  toast.warn('Error deleting entry'+entry_number); // Show warning toast if error
  //}
      if (!hasCalledRemovePerforamnce && !isRemovePerformanceLoading && removePerformanceFetched ) {
      setHasCalledRemovePerforamnce(true);
      if (!errorData?.success) {
        const errorMessage = (errorData?.error)? errorData.error?.error_message:'';      
        if (errorMessage?.includes("Cannot delete or update a parent row:")) {
          toast.warn(
            `Entry ${entry_number} cannot be removed because scores have already been assigned to it!`
          );
        }
      }
      
      if (removedPerformanceData.success) {
        fetchData();
        toast.info(removedPerformanceData.message);
      }
    }
  }, [errorData, isRemovePerformanceLoading, removedPerformanceData, hasCalledRemovePerforamnce, entry_number, removePerformanceFetched, fetchData]);
  
  const getPPLabel = (ranking_final_score: number | null) => {
    if (!ranking_final_score || ranking_final_score === 0) return '';
  
    if (ranking_final_score > 0 && ranking_final_score <= 99) return 'S';
    if (ranking_final_score >= 100 && ranking_final_score <= 149) return 'G';
    if (ranking_final_score >= 150 && ranking_final_score <= 199) return 'HG';
    if (ranking_final_score >= 200 && ranking_final_score <= 249) return 'P';
    if (ranking_final_score >= 250 && ranking_final_score <= 300) return 'DP';
  
    return '';
  };

  const location = useLocation();
  const applyClass = /^\/admin\/performances\/\d+$/.test(location.pathname);

  const canAccessTalktapeActions = !!JSON.parse(localStorage.getItem("user") || '{}')?.modules?.find((m:any) => m.title.toLowerCase() === "talktape")?.ModulesPermissions?.view;
  console.log("canAccessTalktapeActions --- ", canAccessTalktapeActions);
  //const canAccessTalktapeActions = [1,9].includes(currentRole);

  return (
    <div
      className={`${(currentRole == "1" || currentRole == "8" || currentRole == "7") ? 'performance-table-row-performance-admin':'performance-table-row-performance-admin'} performance-table-body scale--sm cursor-pointer ${(is_editing_allowed && Number(secondLastColumn) !== 0) ? 'performance--blue' : ''} ${((currentRole != "1" && currentRole != "8" && currentRole != "7") && !is_editing_allowed) ? 'locked':''}`}
      style={{
        backgroundColor: performanceColor,
      }}
      onClick={() => {
        if (currentRole === 9) {
          // do nothing..
        } else if ((currentRole != "1" || currentRole != "8" || currentRole != "7") && is_editing_allowed) {
          navigate(`/scorecard/${id}`);
        }
      }}
    >
      <div className="item-1" style={{ marginLeft: '10px' }}>{entry_number}</div>
      <div className="item-2">
        {(currentRole == "1" || currentRole == "8" || currentRole == "7")?
          <a href={`/placements/${division_id}`} target='_blank' className="link-without-foramtting">{division}</a>
          :''}
        {(performance_type === "twd" && (currentRole == "1" || currentRole == "8" || currentRole == "7")) && <span className="separator"> | </span>}
        
        {performance_type === "sds" && performers && Array.isArray(performers) ? (
          <div>
            {performers.map((performer) => (
              <div key={performer.id}>
                {performer.user?.first_name} {performer.user?.last_name}
              </div>
            ))}
          </div>
        ) : (
          <span className={applyClass ? "program-text" : ""}>{program}</span>
        )}

        {canAccessTalktapeActions && (
          <MuxActions 
            item={{
              id: talktape?.id || id,
              entry_number: entry_number,
              performance_id: id,
              talktape_video_title:`${event_id}_${entry_number}`,
              mux_asset_id: talktape?.mux_asset_id,
              mux_playback_id: talktape?.mux_playback_id,
              mux_playback_url: talktape?.mux_playback_url,
              status: talktape?.status,
            }}
            onSongUpdate={handleTalktapeUpdate}
          />
        )}
        
      </div>
      <div className="item-3">
        {(currentRole == "1" || currentRole == "8"|| currentRole == "7")?
        <div>
          {ranking_final_score}
          &nbsp;&nbsp;
          {getPPLabel(ranking_final_score)}          
      </div>
        :''}
      </div>
      <div className="item-4">{routine}</div>
      <div className="item-5">
        {type === "admin"
          ? secondLastColumn + ":" + song_id
          : secondLastColumn
          ? `${secondLastColumn}/100`
          : "-/100"}
      </div>
      <div className="item-6" style={{ marginLeft: '15px' }}>{lastColumn}</div> 
      {((currentRole=="1" && edit_delete_allowed == true && pdivisionStatus == "judging") &&
      <div className="item-7">
        <Tooltip title="Edit Performance" enterDelay={0} leaveDelay={0}>
        <span>
          <EditNote
              sx={{ fontSize: "21px", color: "blue" }}
              onClick={(e) => { 
              e.stopPropagation(); // Prevent triggering the row click event
              if (showEditPerformanceForm) {
                let performerslist = "";
                if(performance_type === "sds" && performers && Array.isArray(performers)){
                  performers.map((performer, index) => {
                    performerslist += (index>0) ? ', ' : '';
                    performerslist += `${performer.user?.first_name} ${performer.user?.last_name}`;
                  });
                }
                showEditPerformanceForm(id, entry_number, division_id ?? 0, routine, user_programdirector_id ?? 0, performance_time ?? "", performerslist, playlist_number ?? "", style ?? "", pclass ?? "", grade ?? "", level ?? "", performer_count ?? "", description ?? "", performance_type, Number(song_id), Number(event_id))
              }
            }}
          />
        </span>
        </Tooltip>
        &nbsp;
        <Tooltip title="Delete Performance" enterDelay={0} leaveDelay={0}>
        <span>
          <RemoveCircleOutlineTwoTone
              sx={{ fontSize: "19px", color: "red" }}
              onClick={(e) => { 
              e.stopPropagation(); // Prevent triggering the row click event
              handleDelete(); // Call the delete function when the icon is clicked
            }}
          />
        </span>
        </Tooltip>
      </div>
      )}
    </div>
  );
};

export default PerformanceCard;
